<template>
  <transition name="fade">
    <div
      v-show="enabledPain"
      class="chat-pain"
    >
      <div class="pain-header">
        <span class="pain-close" @click="$emit('onClickClose')">
          <img :src="require('@/assets/images/icons/cross.png')"/>
        </span>
        <span>{{ $t('common.menus.chat') }}</span>
      </div>
      <div class="pain-body">
        <div class="chat-container">
          <div class="chat-messages">
            <div
              v-for="(message, index) in messages"
              :key="index"
              class="chat-message"
            >
              <span class="display-name">{{ message.displayName }}</span>
              <span
                v-html="$options.filters.formatChatPostContent(message.content)"
                class="content"
              />
            </div>
          </div>
          <div class="chat-editor">
            <room-textarea
              v-model="chatMessage"
              :placeholder="$t('common.chatTextAreaPlaceHolderShort')"
              :quotationMode="quotationMode"
              :key="chatMessageRenderingKey"
              @toggleQuotationMode="(mode) => { this.quotationMode = mode }"
            />
            <div class="post-tools">
              <proa-tool-icon
                :src="require('@/assets/images/chat_tool_icons/quotation.png')"
                :active="quotationMode"
                @click.native="onClickQuotationMode"
              />
              <proa-button
                variant="secondary"
                class="chat-send"
                :disabled="!chatMessage"
                @click.native="onClickSend"
              >
                {{ $t('common.send') }}
              </proa-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import RoomTextarea from '@/components/molecules/room/RoomTextarea'

export default {
  name: 'ChatPain',
  components: {
    RoomTextarea
  },
  props: {
    enabledPain: Boolean
  },
  computed: {
    ...mapGetters({
      messages: 'roomChatMessages/messages'
    })
  },
  data() {
    return {
      chatMessage: '',
      chatMessageRenderingKey: 0,
      quotationMode: false,
    }
  },
  methods: {
    onClickQuotationMode: function() {
      this.quotationMode = !this.quotationMode
    },
    onClickSend: function() {
      this.$emit('onClickSend', this.chatMessage)
      this.chatMessage = ''
      ++this.chatMessageRenderingKey
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.chat-pain {
  position: absolute;
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;

  @include mq(md) {
    position: relative;
    width: 350px !important;
  }
}

.pain-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  padding: 0 20px;
  background-color: white;
  border-bottom: 1px solid $dark-border-color;
  font-weight: 600;
  color: $secondary-color;

  &:after {
    display: block;
    content: "";
    width: 26px;
  }

  .pain-close {
    display: inline-block;
    height: 26px;
    width: 26px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      padding: 3px;
    }
  }
}

.pain-body {
  flex-grow: 1;
  position: relative;
  background-color: #FAFAFA;
}

.chat-container {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 130px;
  display: flex;
  flex-direction: column;
}

.chat-messages {
  flex-grow: 1;
  overflow: auto;
  padding: 0 25px;
  display: flex;
  flex-direction: column-reverse;

  .chat-message {
    margin-bottom: 20px;

    .display-name {
      display: block;
      font-size: 12px;
      font-weight: 600;
      color: $secondary-color;
      margin-bottom: 10px;
    }

    .content {
      color: black;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
}

.chat-editor {
  width: 100%;
  height: 80px;
  padding: 0 25px;

  .post-tools {
    background-color: white;
    border: 1px solid $dark-border-color;
    border-top: none;
    border-radius: 0 0 4px 4px;
    padding: 0 15px 10px 15px;
    display: flex;
    justify-content: space-between;

    button {
      font-size: 12px;
      font-weight: 600;
      padding: 5px 15px;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transform: translate(0px, 0px);
  transition: transform .3s;
}
.fade-enter, .fade-leave-to {
  transform: translateX(100vw) translateX(0px);

  @include mq(md) {
    transform: translateX(350px) translateX(0px);
  }
}
</style>
